import { Mask, Validations } from '../../class/workflow.type';

import { InputMaskProcessingBase, InputMaskProcessingBaseConstructor, InputStatus } from './input-mask-processing.base';
import { maskRegistry } from './input-mask.registry';

/**
 * Get mask class by name (or fallback to dummy mask class)
 * @param maskName a registered mask type
 * @return mask class (defaults to dummy mask)
 */
export const getMaskClass = (maskName: Mask): InputMaskProcessingBaseConstructor => maskRegistry[maskName] || maskRegistry.dummy;

/**
 * Apply a mask
 * @param maskName a registered mask type
 * @param value string to process
 * @param validations field config for validations
 * @return masked string
 */
export const maskValue = (maskName: Mask, value: string, validations?: Validations): string => {
  const mask = new (getMaskClass(maskName))({ value }, null, validations);
  mask.process();
  return mask.processed.value;
};

/**
 * Apply a mask for an input element
 * @param maskName a registered mask type
 * @param state current InputStatus on input DOM element
 * @param prevState previous InputStatus on input DOM element
 * @param validations field config for validations
 * @return Mask object that has been processed
 */
export const maskInput = (
  maskName: Mask,
  state: InputStatus,
  prevState: InputStatus,
  validations?: Validations
): InputMaskProcessingBase => {
  const mask = new (getMaskClass(maskName))(state, prevState, validations);
  mask.process();
  return mask;
};
